(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anchors"] && !Shopify.designMode) return;
  try {
    

// ScrollSmoother.scrollTo is used for smooth scrolling if ScrollSmoother is available
document.addEventListener('DOMContentLoaded', function() {

  function smoothScrollTo(targetId) {
    const el = document.getElementById(targetId);
    if (!el) return;
    if (ScrollSmootherEl) {
      ScrollSmootherEl.scrollTo(el, { offset: -100, smooth: 2 });
    } else {
      window.scrollTo({
        top: el.getBoundingClientRect().top + window.pageYOffset - 100,
        behavior: 'smooth'
      });
    }
  }

  // Mobile select
  const selectEl = document.querySelector('.anchors-list-mobile .select__select');
  if (selectEl) {
    selectEl.addEventListener('change', function(e) {
      if (e.target.value === "") return;
      const id = e.target.value.split('#')[1];
      if (id) { smoothScrollTo(id); }
      e.target.value = "";
    });
  }

  // Desktop links
  document.querySelectorAll('.anchors-list .button').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const id = link.getAttribute('href').split('#')[1];
      if (id) smoothScrollTo(id);
    });
  });



});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    
    if (Shopify && Shopify.designMode) {
      return;
    }

    const parallaxItems = document.querySelectorAll('.parallax-item');

      if (window.gsap && window.ScrollTrigger) {
        parallaxItems.forEach((item) => {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: item,
              start: function() {

                if (window.innerWidth < 768) {
                  return 'top 100%';
                }

                return 'top 80%';

              },
              end: function() {

                if (window.innerWidth < 768) {
                  return 'bottom 0%';
                }

                return 'bottom 20%';

              },
              scrub: true,
            }
          });

          tl.fromTo(
            item,
            { y: 60, scale: 0.95 },
            { y: 0, scale: 1, duration: 1, ease: 'power2.out' },
            0
          );

          tl.fromTo(
            item,
            { opacity: 0.7 },
            { opacity: 1,  duration: function() {

              if (window.innerWidth < 768) {
                return 0.25;
              }

              return 0.5;

            }, ease: 'power2.out' },
            0
          );

        });
      } else {
        console.warn('GSAP or ScrollTrigger not loaded');
      }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  (function() {

    // add after-1s class to body after 1 second to delay certain transitions
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(function() {
        document.body.classList.add('after-1s');
      }, 1000);
    });

  })();

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const slideshowComponent = document.querySelector('slideshow-component');
    const header = document.querySelector('.section-header');
    
    if (!slideshowComponent || !header) return;
    
    // Add header overlap class
    header.classList.add('header-over-diapo');
    
    function updateMenuColor() {
      const activeSlide = slideshowComponent.querySelector('.slideshow__slide--active');
      if (!activeSlide) return;
      
      const menuColor = activeSlide.getAttribute('data-menu-color');
      if (menuColor) {
        header.style.setProperty('--menu-color', menuColor);
      }
    }
    
    // Set initial menu color
    updateMenuColor();
    
    // Listen for slide changes
    slideshowComponent.addEventListener('slideChanged', updateMenuColor);

    // if there is only one slide, ensure the menu color is set
    const slides = slideshowComponent.querySelectorAll('.slideshow__slide');
    if (slides.length === 1) {
      const menuColor = slides[0].getAttribute('data-menu-color');
      if (menuColor) {
        header.style.setProperty('--menu-color', menuColor);
      }
    }

  });

  } catch(e) { console.error(e); }
})();
})();
